import type { Theme } from '@mui/material/styles';

export const getStatusStyle = (theme: Theme, status: string) => {
  const baseStyle = {
    fontWeight: 'bold',
  };
  switch (status) {
    case 'open':
      return {
        ...baseStyle,
        backgroundColor: theme.palette.bidlogiq.taupe,
        color: theme.palette.common.black,
      };
    case 'in_progress':
      return {
        ...baseStyle,
        backgroundColor: theme.palette.bidlogiq.camel,
        color: theme.palette.common.black,
      };
    case 'waiting-response':
      return {
        ...baseStyle,
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
      };
    case 'resolved':
      return {
        ...baseStyle,
        backgroundColor: theme.palette.success.main,
        color: theme.palette.success.contrastText,
      };
    case 'closed':
      return {
        ...baseStyle,
        backgroundColor: theme.palette.greyContrast,
        color: theme.palette.primary.contrastText,
      };
    default:
      return {
        ...baseStyle,
        backgroundColor: theme.palette.greyContrast,
        color: theme.palette.common.white,
      };
  }
};

export const getPriorityStyle = (theme: Theme, priority: string) => {
  const baseStyle = {
    color: theme.palette.common.white,
    fontWeight: 'bold',
  };
  switch (priority) {
    case 'urgent':
      return { ...baseStyle, backgroundColor: theme.palette.bidlogiq.rust };
    case 'high':
      return { ...baseStyle, backgroundColor: '#FFC107' };
    case 'medium':
      return { ...baseStyle, backgroundColor: theme.palette.bidlogiq.brown };
    case 'low':
      return { ...baseStyle, backgroundColor: theme.palette.bidlogiq.black };
    default:
      return { ...baseStyle, backgroundColor: theme.palette.greyContrast };
  }
};

export const formatTimestamp = (
  timestamp: Date | { seconds: number } | string | number | null | undefined
): string => {
  if (!timestamp) {
    return 'N/A';
  }
  try {
    if (
      timestamp &&
      typeof timestamp === 'object' &&
      'seconds' in timestamp &&
      typeof timestamp.seconds === 'number'
    ) {
      return new Date(timestamp.seconds * 1000).toLocaleString();
    }
    if (timestamp instanceof Date) {
      return timestamp.toLocaleString();
    }
    if (typeof timestamp === 'string' && !Number.isNaN(Date.parse(timestamp))) {
      return new Date(timestamp).toLocaleString();
    }
    if (typeof timestamp === 'number') {
      return new Date(timestamp).toLocaleString();
    }
    return 'Invalid date';
  } catch {
    return 'Invalid date';
  }
};
